module.exports = __webpack_public_path__ + "img/hipercard.d6495071.svg";